<div class="customers-list__container">
  <div class="customers-list__header" fxLayout="row nowrap" fxLayoutAlign="space-between center">
    <div
      class="customers-list__header__container"
      fxLayout="column nowrap"
      fxLayout.mm-gt-tablet="row nowrap"
      fxLayoutAlign.mm-gt-tablet="start center"
    >
      <h2 class="customers-list__header__title__text">
        {{ 'PAGES.AUTH.CUSTOMERS.SEARCH_PAGE.TITLE.TEXT' | translate }}
      </h2>
      <div class="customers-search-box" fxLayout="row nowrap" novalidate>
        <form [formGroup]="searchFormElement" class="customers-search-box__wrapper">
          <div class="customers-search-box__group">
            <div class="customers-search-box__submit">
              <mm-icon
                [ngClass]="{ 'disabled-icon-class': !isImpersonationAllowed }"
                (click)="onSubmit()"
                name="search"
                class="customers-search-box__submit__icon"
              ></mm-icon>
            </div>
            <input
              [mmTestTarget]="'customers-search-box-input'"
              type="search"
              [ngClass]="{ 'disabled-input-class': !isImpersonationAllowed }"
              class="customers-search-box__field"
              [placeholder]="'PAGES.AUTH.CUSTOMERS.SEARCH_FIELD.PLACEHOLDER.TEXT' | translate"
              formControlName="searchTerm"
              (keydown)="onKeydown($event)"
              (keyup.enter)="triggerInvokedSearchTerm()"
              (focus)="onFocus()"
              (blur)="onBlur()"
            />
          </div>
        </form>
        <div class="customers-search-box__buttons">
          <div class="customers-search-box__submit">
            <button
              mm-button
              color="primary"
              size="large"
              raised="true"
              iconOffset="true"
              type="submit"
              [disabled]="!isImpersonationAllowed"
              [loading]="dataLoading"
              (click)="onSubmit()"
            >
              {{ 'PAGES.AUTH.CUSTOMERS.SEARCH_BUTTON.TEXT' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mm-table-container
    class="customers-list-table"
    [ngClass]="{ 'initial-table': !isSearchTriggered, 'has-no-results': !totalCount || error }"
  >
    <mm-table-loader *ngIf="dataLoading"></mm-table-loader>
    <mm-table-empty-state-template
      class="no-results"
      *ngIf="!dataLoading && !error && !totalCount && isSearchTriggered"
    >
      <h4 class="no-results__text-1">{{ 'PAGES.AUTH.CUSTOMERS.TABLE.NO_RESULTS_FOUND.TEXT' | translate }}</h4>

      <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.5 29.9998C0.5 13.4315 13.931 -0.000244141 30.5 -0.000244141C47.0682 -0.000244141 60.5 13.4315 60.5 29.9998C60.5 46.568 47.0682 59.9998 30.5 59.9998C13.931 59.9998 0.5 46.568 0.5 29.9998ZM43.5604 43.0603C44.1462 42.4746 44.1462 41.5251 43.5604 40.9393L32.6209 29.9998L43.5604 19.0603C44.1462 18.4746 44.1462 17.5251 43.5604 16.9393C42.9747 16.3536 42.0252 16.3536 41.4394 16.9393L30.5 27.8788L19.5604 16.9393C18.9747 16.3536 18.0252 16.3536 17.4394 16.9393C16.8537 17.5251 16.8537 18.4746 17.4394 19.0603L28.379 29.9998L17.4394 40.9393C16.8537 41.5251 16.8537 42.4746 17.4394 43.0603C17.7319 43.3536 18.1159 43.4998 18.5 43.4998C18.8839 43.4998 19.2672 43.3536 19.5604 43.0603L30.5 32.1208L41.4394 43.0603C41.7319 43.3536 42.1159 43.4998 42.4999 43.4998C42.8839 43.4998 43.2672 43.3536 43.5604 43.0603Z"
          fill="#DE351B"
        />
      </svg>

      <p class="no-results__text-2">
        {{ 'PAGES.AUTH.CUSTOMERS.TABLE.NO_RESULTS_FOUND_FOR.TEXT' | translate }}:<br /><b>{{ searchTerm }}</b>
      </p>

      <p class="no-results__text-3">
        {{ 'PAGES.AUTH.CUSTOMERS.TABLE.NO_RESULTS_FOUND_NOTICE.TEXT' | translate }}
      </p>
    </mm-table-empty-state-template>

    <mm-table-empty-state-template
      *ngIf="!dataLoading && !error && !totalCount && !isSearchTriggered && !isImpersonationAllowed"
    >
      <div class="impersonation-not-allowed-table-container">
        <div class="impersonation-not-allowed-table-container__box">
          <h3 class="impersonation-not-allowed-table-container__header">
            {{ 'PAGES.AUTH.CUSTOMERS.TABLE.IMPERSONATION.NOT.ALLOWED.HINT.TITLE' | translate }}
          </h3>
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 61 60" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.5002 29.9998C0.5002 13.4315 13.9312 -0.000244141 30.5002 -0.000244141C47.0684 -0.000244141 60.5002 13.4315 60.5002 29.9998C60.5002 46.568 47.0684 59.9998 30.5002 59.9998C13.9312 59.9998 0.5002 46.568 0.5002 29.9998ZM43.5606 43.0603C44.1464 42.4746 44.1464 41.5251 43.5606 40.9393L32.6211 29.9998L43.5606 19.0603C44.1464 18.4746 44.1464 17.5251 43.5606 16.9393C42.9749 16.3536 42.0254 16.3536 41.4396 16.9393L30.5002 27.8788L19.5606 16.9393C18.9749 16.3536 18.0254 16.3536 17.4396 16.9393C16.8539 17.5251 16.8539 18.4746 17.4396 19.0603L28.3792 29.9998L17.4396 40.9393C16.8539 41.5251 16.8539 42.4746 17.4396 43.0603C17.7321 43.3536 18.1161 43.4998 18.5002 43.4998C18.8841 43.4998 19.2674 43.3536 19.5606 43.0603L30.5002 32.1208L41.4396 43.0603C41.7321 43.3536 42.1161 43.4998 42.5001 43.4998C42.8841 43.4998 43.2674 43.3536 43.5606 43.0603Z"
              fill="#DE351B"
            />
          </svg>

          <span class="impersonation-not-allowed-table-container__info-text"
            [innerHTML]="'PAGES.AUTH.CUSTOMERS.TABLE.IMPERSONATION.NOT.ALLOWED.HINT.TEXT' | translate">
          </span>
          <div>
            <button
              class="impersonation-not-allowed-table-container__logout-button"
              mm-button
              color="primary"
              size="large"
              raised="true"
              iconOffset="true"
              type="submit"
              (click)="logout($event)"
            >
              {{ 'CORE.ALL_PAGES.USER_BOX.LOG_OUT.LABEL' | translate }}
            </button>
          </div>
        </div>
      </div>
    </mm-table-empty-state-template>

    <mm-table-empty-state-template
      class="empty-table-container"
      *ngIf="!dataLoading && !error && !totalCount && !isSearchTriggered && isImpersonationAllowed"
    >
      <h3>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.EMPTY.HINT.TITLE' | translate }}</h3>

      <svg width="88" height="82" viewBox="0 0 88 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30.0667" cy="30.0667" r="30.0667" fill="#0064FE" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.0672 0C13.4618 0 0.000488281 13.4613 0.000488281 30.0667C0.000488281 40.21 5.02335 49.1802 12.7175 54.6256C17.7884 52.3858 19.7522 51.4716 19.7522 51.4716C19.7522 51.4716 20.2517 50.9772 20.7512 49.7064C21.251 48.4354 20.7512 47.447 20.7512 47.447L23.2616 46.8115C23.2616 46.8115 23.0352 42.6459 23.2493 42.6459C23.2848 42.6459 23.2144 42.5351 23.0715 42.3104C22.6281 41.6129 21.487 39.8179 20.6497 36.8312C20.0533 36.7537 19.1214 36.0242 18.7531 32.9729C18.437 30.3552 18.9513 29.8348 19.4739 29.8919C19.4612 29.5998 19.4539 29.3054 19.4521 29.0091C18.8392 27.7635 17.9804 25.5631 17.7096 22.6143C17.2731 17.8612 18.9099 12.8921 18.9099 12.8921C18.9099 12.8921 20.5467 14.4045 25.5662 12.6761C30.5857 10.9477 36.9146 10.9477 38.4423 13.3242C39.97 15.7007 39.3153 17.4291 39.3153 17.4291C39.3153 17.4291 43.4618 20.2377 42.3706 24.5587C41.8101 26.7783 41.0192 28.5988 40.3826 29.8446C40.3819 29.8603 40.3812 29.876 40.3806 29.8917L40.4359 29.8914C40.9523 29.8478 41.452 30.384 41.1397 32.9729C40.7653 36.0741 39.8081 36.778 39.2134 36.8352C38.3759 39.8197 37.2358 41.6135 36.7927 42.3105C36.6499 42.5351 36.5795 42.6459 36.615 42.6459C36.8291 42.6459 36.6027 46.8115 36.6027 46.8115L39.1131 47.447C39.1131 47.447 38.6135 48.4354 39.1131 49.7064C39.6126 50.9772 40.1121 51.4716 40.1121 51.4716C40.1121 51.4716 42.1188 52.4057 47.3129 54.6989C55.0657 49.2608 60.1338 40.2556 60.1338 30.0667C60.1338 13.4613 46.6725 0 30.0672 0Z"
          fill="#E5EFFF"
        />
        <circle cx="57.3987" cy="51.9335" r="30.0667" fill="#0064FE" />
        <mask
          id="mask0_1189_84914"
          style="mask-type: luminance"
          maskUnits="userSpaceOnUse"
          x="27"
          y="21"
          width="61"
          height="61"
        >
          <circle cx="57.3987" cy="51.9329" r="30.0667" fill="white" />
        </mask>
        <g mask="url(#mask0_1189_84914)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M87.4654 21.8662H27.332V81.9995H30.8555C31.2571 80.6972 32.3327 78.9374 34.8821 77.661C39.4358 75.3813 47.2211 71.9251 47.2944 71.9251C47.5149 67.8072 50.0854 67.0717 50.0854 67.0717L50.2347 65.2442C44.8727 64.4571 41.6391 62.2919 41.6391 62.2919C41.6391 62.2919 43.255 61.7036 44.9441 56.1149C45.5398 54.1445 45.5602 51.9091 45.5816 49.5664C45.6209 45.2645 45.6635 40.601 49.2776 36.5542C52.2346 33.243 55.2327 32.7178 57.3987 32.9561C59.5647 32.7178 62.5628 33.243 65.5198 36.5542C69.1338 40.6011 69.1764 45.2646 69.2157 49.5666C69.2371 51.9092 69.2575 54.1446 69.853 56.1149C71.5424 61.7036 73.1581 62.2919 73.1581 62.2919C73.1581 62.2919 69.9244 64.4571 64.5627 65.2442L64.712 67.0717C64.712 67.0717 67.2825 67.8072 67.5028 71.9251C67.5763 71.9251 75.3616 75.3813 79.9153 77.661C82.4646 78.9374 83.5403 80.6972 83.9419 81.9995H87.4654V21.8662Z"
            fill="#E5EFFF"
          />
        </g>
      </svg>

      <p>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.EMPTY.HINT.TEXT' | translate }}</p>
    </mm-table-empty-state-template>
    <mm-table-empty-state-template class="error-result" *ngIf="!dataLoading && !!error">
      <h4 class="no-results__text-1">
        {{ 'PAGES.AUTH.CUSTOMERS.TABLE.ERROR_OCCURED.TEXT' | translate }}
      </h4>

      <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="60" height="60" rx="30" fill="#DE351B" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.1802 37.2802C32.1802 34.1879 34.6879 31.6802 37.7802 31.6802C40.8725 31.6802 43.3802 34.1879 43.3802 37.2802C43.3802 40.3725 40.8725 42.8802 37.7802 42.8802C34.6879 42.8802 32.1802 40.3725 32.1802 37.2802Z"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M35.54 35.04L40.02 39.52" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M35.54 39.52L40.02 35.04" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M42.1822 30.7931C42.2304 30.3484 42.2606 29.8982 42.2606 29.4401C42.2606 22.6361 36.7446 17.1201 29.9406 17.1201C23.1355 17.1201 17.6206 22.6361 17.6206 29.4401C17.6206 36.2441 23.1355 41.7601 29.9406 41.7601C30.3976 41.7601 30.8478 41.731 31.2924 41.6828"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.9402 41.7601C26.2285 41.7601 23.2202 36.2441 23.2202 29.4401C23.2202 22.6361 26.2285 17.1201 29.9402 17.1201C33.6519 17.1201 36.6602 22.6361 36.6602 29.4401"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M29.9399 17.1201V41.7601" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M42.2601 29.4399H17.6201" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M19.8604 22.7202H40.0204" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M19.8604 36.1602H29.9404" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <p class="error-result__text-2">
        {{ 'PAGES.AUTH.CUSTOMERS.TABLE.ERROR_OCCURED_HINT.TEXT' | translate }}
      </p>
    </mm-table-empty-state-template>
    <table mm-table mmSort [dataSource]="dataSource">
      <ng-container mmColumnDef="fullName">
        <th mmHeaderCell *mmHeaderCellDef>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.METRO_CARD.TEXT' | translate }}</th>
        <td mmCell mmFontWeight="bold" *mmCellDef="let item">
          {{ formatCardNumber(item.metroCard) || '—' }}
        </td>
      </ng-container>

      <ng-container mmColumnDef="metroCard">
        <th mmHeaderCell *mmHeaderCellDef>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.FULL_NAME.TEXT' | translate }}</th>
        <td mmCell *mmCellDef="let item">
          {{ item.fullName || '—' }}
        </td>
      </ng-container>

      <ng-container mmColumnDef="companyName">
        <th mmHeaderCell *mmHeaderCellDef>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.COMPANY_NAME.TEXT' | translate }}</th>
        <td mmCell *mmCellDef="let item">
          {{ item.companyName || '—' }}
        </td>
      </ng-container>

      <ng-container mmColumnDef="formattedAddress">
        <th mmHeaderCell *mmHeaderCellDef>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.ADDRESS.TEXT' | translate }}</th>

        <td mmCell *mmCellDef="let item">
          <ng-container *ngIf="item.formattedAddress?.length > 25; else normalAddress">
            <span
              [mmTooltip]="formattedAddressTooltipContent"
              [mmTooltipHideDelay]="400"
              mmTooltipColor="blue"
              mmTooltipPlacement="bottom"
              [mmTooltipOptions]="tooltipOptions"
              >{{ item.formattedAddress ? truncate(item.formattedAddress, { length: 25 }) : '—' }}</span
            >

            <ng-template #formattedAddressTooltipContent>
              <p>{{ item.formattedAddress }}</p>
            </ng-template>
          </ng-container>
          <ng-template #normalAddress> {{ item.formattedAddress || '—' }}</ng-template>
        </td>
      </ng-container>

      <ng-container mmColumnDef="email">
        <th mmHeaderCell *mmHeaderCellDef>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.EMAIL.TEXT' | translate }}</th>
        <td mmCell *mmCellDef="let item">
          <strong>{{ item.email || '—' }}</strong>
        </td>
      </ng-container>

      <ng-container mmColumnDef="hasDigitalIdentity">
        <th mmHeaderCell *mmHeaderCellDef>
          {{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.HAS_DIGITAL_IDENTITY.TEXT' | translate }}
        </th>
        <td mmCell mmTextAlign="center" *mmCellDef="let item">
          <mm-icon
            [name]="item.hasDigitalIdentity ? 'alert-success-small' : 'cancel'"
            [ngClass]="{
              success: item.hasDigitalIdentity,
              error: !item.hasDigitalIdentity
            }"
          ></mm-icon>
        </td>
      </ng-container>

      <ng-container mmColumnDef="Action" sticky>
        <th mmHeaderCell *mmHeaderCellDef>{{ 'PAGES.AUTH.CUSTOMERS.TABLE.COLUMN.ACTION.TEXT' | translate }}</th>
        <td mmCell *mmCellDef="let item">
          <ng-container [ngSwitch]="getStatus(item)">
            <ng-container *ngSwitchCase="'VALIDATED'">
              <button
                class="action-button"
                mm-button
                color="primary"
                size="small"
                raised="true"
                iconOffset="true"
                (click)="impersonateCustomer(item.personCdmId, item.businessCdmId, item.hasDigitalIdentity, item.email, item.metroCard)"
              >
                {{ 'PAGES.AUTH.CUSTOMERS.BUTTON.IMPERSONATE.TEXT' | translate }}
              </button>
            </ng-container>
            <ng-container *ngSwitchCase="'BLOCKED'">
              <button
                class="action-button"
                mm-button
                disabled
                color="primary"
                size="small"
                raised="true"
                iconOffset="true"
              >
                {{ 'PAGES.AUTH.CUSTOMERS.BUTTON.IMPERSONATE.TEXT.BLOCKED' | translate }}
              </button>
            </ng-container>
            <ng-container *ngSwitchCase="'PENDING'">
              <button
                class="action-button"
                mm-button
                disabled
                color="primary"
                size="small"
                raised="true"
                iconOffset="true"
              >
                {{ 'PAGES.AUTH.CUSTOMERS.BUTTON.IMPERSONATE.TEXT.PENDING' | translate }}
              </button>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>
      <tr mm-header-row *mmHeaderRowDef="displayedColumns"></tr>
      <tr mm-row *mmRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mm-table-container>
</div>
